import { _axios } from '@/plugins/axios';

const subClaimsResource = '/api/v1/sub-claims';

export default {
  all: claimId => _axios.get(`${subClaimsResource}/mapped/${claimId}`),
  create: subClaim => _axios.post(`${subClaimsResource}/create`, subClaim),
  delete: id => _axios.delete(`${subClaimsResource}/delete/${id}`),
  getSubClaimById: subClaimId => _axios.get(`${subClaimsResource}/${subClaimId}`),
  update: subClaim => _axios.put(`${subClaimsResource}/update`, subClaim),
  getScores: () => _axios.get(`${subClaimsResource}/scores`),
  getEvidencesCount: subClaimId => _axios.get(`/api/v1/evidences/mapped/${subClaimId}`),
  checkDuplicateName: title => _axios.get(`${subClaimsResource}/check-duplicate-name/${title}`),
};
